import './DetailSection.style.less'
import { Button, Empty, message, Spin, Tabs } from 'antd'
import { first, get, orderBy } from 'lodash'
import moment from 'moment'
import { useEffect } from 'react'
import { IOrderSectionDetail } from '@/screens/Order/interface'
import TaskTemplate from './components/TaskTemplate/TaskTemplate'
import { CloseOutlined } from '@ant-design/icons'
import { getMostRecentDate } from '@/utils/date'
import Fade from '@/components/Fade'

const { TabPane } = Tabs

interface Prop {
  activeSection: string
  onCurrentOrderSectionChange: (sectionId: string) => any
  sectionData: IOrderSectionDetail[]
  sectionLoading: boolean
  sectionError: any
  refetch: Function
  onCloseTask: () => void
}

function DetailSection(prop: Prop) {
  const {
    onCurrentOrderSectionChange,
    sectionData,
    sectionLoading,
    sectionError,
  } = prop

  useEffect(() => {
    sectionError && message.error('Unable to load order list')
  }, [sectionError])

  useEffect(() => {
    if (!prop.activeSection) {
      onCurrentOrderSectionChange(
        get(first(orderBy(sectionData, ['display_order'], ['asc'])), 'id')
      )
    }
  }, [prop.activeSection, sectionData])

  return (
    <Fade>
      <Spin spinning={sectionLoading} indicator={<Spin />}>
        <div className="time-action-detail-section-container">
          <div className="pbf-col-12">
            <div className="main chart">
              {!sectionData ? (
                <Empty style={{ margin: 'auto' }} />
              ) : sectionData?.length === 0 ? (
                <Empty style={{ margin: 'auto' }} />
              ) : (
                <Tabs
                  activeKey={prop.activeSection ?? ''}
                  onChange={(id) => {
                    onCurrentOrderSectionChange(id)
                  }}
                  tabBarExtraContent={
                    <Button
                      onClick={prop.onCloseTask}
                      type="text"
                      icon={<CloseOutlined />}
                    />
                  }
                >
                  {orderBy(sectionData, ['display_order'], ['asc']).map(
                    (section: any) => {
                      return (
                        <TabPane
                          tab={<div>{section.name}</div>}
                          key={`${section.id}`}
                        >
                          {section?.tasks && (
                            <>
                              <div className="row">
                                <div className="col-md-6">
                                  <span className="section-title">
                                    Last update on{' '}
                                    {moment(
                                      getMostRecentDate(section.tasks)
                                    ).format('DD MMM YYYY')}
                                  </span>
                                </div>
                              </div>
                              {orderBy(
                                section.tasks,
                                ['display_order'],
                                ['asc']
                              ).map((task: any, index) => {
                                return <TaskTemplate key={index} data={task} />
                              })}
                              {!section?.tasks.length && (
                                <div
                                  style={{
                                    height: '300px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Empty description={<span>No Task</span>} />
                                </div>
                              )}
                            </>
                          )}
                        </TabPane>
                      )
                    }
                  )}
                </Tabs>
              )}
            </div>
          </div>
          <div id="bottom"></div>
        </div>
      </Spin>
    </Fade>
  )
}

export default DetailSection
